import { useDataFormStore } from "@/stores/form";

export function renderRequiredRule(message, trigger = "blur") {
  return {
    required: true,
    message: message,
    trigger,
  };
}

export function renderValidator({ validatorFunc, message, trigger = "blur" }) {
  return {
    validator: (rule, value, callback) => {
      if (validatorFunc(value)) {
        return true;
      }
      callback(new Error(message));
    },
    trigger,
  };
}

export const renderLengthFieldRule = ({
  min,
  max,
  message,
  trigger = "blur",
}) => ({ min, max, message, trigger });

export function checkValidityInn(inn) {
  return checkValidityRuInn(inn) || checkValidityKzInn(inn)
}

export function checkCityInside() {
  const dataForm = useDataFormStore();
  return !(dataForm['sender']['cityFrom'] == dataForm['consignee']['cityTo']);
}

export function checkValidityRuInn(inn) {
  if (inn === "") {
    return true
  }
  var checkDigit = function (inn, coefficients) {
    var n = 0;
    for (var i in coefficients) {
      n += coefficients[i] * inn[i];
    }
    return parseInt((n % 11) % 10);
  };

  switch (inn.length) {
    case 10:
      var n10 = checkDigit(inn, [2, 4, 10, 3, 5, 9, 4, 6, 8]);
      if (n10 === parseInt(inn[9])) {
        return true;
      }
      break;
    case 12:
      var n11 = checkDigit(inn, [7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
      var n12 = checkDigit(inn, [3, 7, 2, 4, 10, 3, 5, 9, 4, 6, 8]);
      if (n11 === parseInt(inn[10]) && n12 === parseInt(inn[11])) {
        return true;
      }
      break;
  }

  return false;
}

function countWords(inn, firstElem) {
  return [...inn].filter(item => item == firstElem)
}

export function checkValidityKzInn(inn) {
  if (inn.length != 12 || countWords(inn, inn[0]).length === 12)
  return false;

let dgt12;

dgt12 = (1 * parseInt(inn[0]) +
       2 * parseInt(inn[1]) +
       3 * parseInt(inn[2]) +
       4 * parseInt(inn[3]) +
       5 * parseInt(inn[4]) +
       6 * parseInt(inn[5]) +
       7 * parseInt(inn[6]) +
       8 * parseInt(inn[7]) +
       9 * parseInt(inn[8]) +
      10 * parseInt(inn[9]) +
      11 * parseInt(inn[10])) % 11;

if (dgt12 == 10)
{
  dgt12 = (3 * parseInt(inn[0]) +
           4 * parseInt(inn[1]) +
           5 * parseInt(inn[2]) +
           6 * parseInt(inn[3]) +
           7 * parseInt(inn[4]) +
           8 * parseInt(inn[5]) +
           9 * parseInt(inn[6]) +
          10 * parseInt(inn[7]) +
          11 * parseInt(inn[8]) +
           1 * parseInt(inn[9]) +
           2 * parseInt(inn[10])) % 11;
}

return dgt12 == parseInt(inn[11]);
}

